<template>
  <div>
    <CRow class="mt-3 mb-4">
      <CCol md="4">
        <label class="d-block">Periodo:</label>
        <DateSelector class="z-custom-2 mb-2" :date="filter.periodo" @input="setPeriodo" />
      </CCol>
      <CCol col="10" class="pt-3">
        <CButton @click="actualizarInfo" color="primary"> Buscar</CButton>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      :title="'Eliminar ' + (deletePromptMeta.length > 1 ? 'documentos' : 'documento')"
      :centered="true"
      color="primary"
      :show="deletePrompt"
      :fade="true"
      >¿Seguro de eliminar {{ deletePromptMeta.length > 1 ? 'documentos' : 'documento' }}?
      <template #footer>
        <CButton @click="deletePrompt = false" color="secondary">Cancelar</CButton>
        <CButton @click="deletePromptAction" color="primary">Aceptar</CButton>
      </template>
    </CModal>
    <div class="w-100 d-flex justify-content-center align-items-center" v-if="isLoading">
      <div class="sk-flow">
        <div class="sk-flow-dot bg-primary"></div>
        <div class="sk-flow-dot bg-primary"></div>
        <div class="sk-flow-dot bg-primary"></div>
      </div>
    </div>
    <datatable v-else
      :columns="columns"
      :data="xdata"
      :total="total"
      :query="query"
      :tbl-style="tblStyle"
      :HeaderSettings="false"
      :Pagination="true"
      :selection="selection"
      :pageSizeOptions="[10, 50, 100, 1000]"
    >
      <div slot="ubicaciones" slot-scope="props" :class="{'ceil-error': props.rowData.errors.includes('ubicaciones')}">
        <Treeselect
          :ref="'ubicacion-' + props.rowIndex"
          placeholder="Ubicación ..."
          :options="ubicacionesArbol"
          :multiple="true"
          :clearable="false"
          :append-to-body="true"
          :open-on-focus="true"
          :open-on-click="true"
          :value="
            ubicacionesArbol.length > 0 ? props.rowData.ubicaciones : null
          "
          @input="
            [
              (props.rowData.ubicaciones = $event),
              onTreeSelect('ubicacion', props.rowIndex),
            ]
          "
        >
         <div slot="value-label" slot-scope="{ node }" :class="{'ubi-error': node.label.includes('unknown')}">{{ node.label.includes('(unknown)') ? 'Selecciona...' : node.label }}</div>
        </Treeselect>
      </div>
      <div slot="cultivo_id" slot-scope="props" :class="{'ceil-error': props.rowData.errors.includes('cultivo_id')}">
        <Treeselect
          :ref="'cultivo-' + props.rowIndex"
          placeholder="Cultivos ..."
          :options="cultivos"
          :searchable="true"
          :clearable="false"
          :open-on-click="true"
          :open-on-focus="true"
          :append-to-body="true"
          :value="cultivos.length > 0 ? props.rowData.cultivo_id : null"
          @input="
            [
              (props.rowData.cultivo_id = $event),
              onTreeSelect('cultivo', props.rowIndex),
            ]
          "
        >
         <div slot="value-label" slot-scope="{ node }">{{ node.label.includes('(unknown)') ? 'Selecciona...' : node.label }}</div>
        </treeselect>
      </div>
      <div slot="embalaje" slot-scope="props" :class="{'ceil-error': props.rowData.errors.includes('embalaje')}">
        <Treeselect
          :key="keys.embalaje"
          :ref="'embalaje-' + props.rowIndex"
          placeholder="Embalajes ..."
          :options="embalajes(props.rowData.cultivo_id)"
          :searchable="true"
          :clearable="false"
          :open-on-click="true"
          :open-on-focus="true"
          :append-to-body="true"
          :value="props.rowData.embalaje"
          @input="
            [
              (props.rowData.embalaje = $event),
              onTreeSelect('embalaje', props.rowIndex),
            ]
          "
        >
         <div slot="value-label" slot-scope="{ node }">{{ node.label.includes('(unknown)') ? 'Selecciona...' : node.label }}</div>
        </treeselect>
      </div>
      <template slot="error" slot-scope="props">
        <p class="error-text" :title="props.rowData.error">{{ props.rowData.error }}</p>
      </template>
      <div slot="actions" slot-scope="props">
        <CButton
          :ref="'action-' + props.rowIndex"
          @click="onDeleteItem(props)"
          color="danger"
          square
          size="sm"
          class="p-0"
        >
          <CIcon name="cil-trash" />
        </CButton>
        <CButton
          v-if="props.rowData.dirty"
          :ref="'action-' + props.rowIndex"
          @click="onUndoItem(props)"
          color="secondary"
          square
          size="sm"
          class="p-0"
        >
          <CIcon name="cil-action-undo" />
        </CButton>
      </div>
      <div v-if="selection.length">
        <div class="d-flex pt-4">
          <div class="col pl-0">
            <masivo :selection="selection" :ubicaciones="ubicacionesArbol" :cultivos="cultivos" :fields="[{
              nombre:'Ubicaciones',
              field: 'ubicaciones'
            }, {
              nombre:'Cultivos',
              field: 'cultivo_id'
            }]" @update-all="updateAll"></masivo>
          </div>
          <div class="col-auto pr-0">
            <CButton
              @click="onDeleteAll"
              color="danger"
              square
            >
              <CIcon name="cil-trash" />
            </CButton>
          </div>
        </div>
      </div>
    </datatable>
    <div hidden> {{ touches }} </div>
  </div>
</template>

<script>
import Datatable from 'vue2-datatable-component';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import DateSelector from "@/customComponents/DateSelector";

import mixin from './mixin/'

export default {
  name: 'Entregas',
  mixins: [mixin],
  props: {
    cultivos: {
      default: []
    },
  },
  components: {
    Datatable,
    Treeselect,
    DateSelector,
  },
  data() {
    return {
      schema: 'entregas',
      columns: [
        {
          title: 'Fecha hora',
          field: 'fechahora_amigable',
          sortable: true,
          filterable: true,
          thComp: 'FilterTh',
          colStyle: {
            width: '145px',
          }
        },
        {
          title: 'Ubicaciones',
          field: 'ubicaciones',
          sortable: true,
          tdClass: 'td-overflow',
          colStyle: {
            width: '200px'
          }
        },
        {
          title: 'Cultivo',
          field: 'cultivo_id',
          sortable: true,
          filterable: true,
          thComp: 'FilterTh',
          lists: 'cultivos',
          tdClass: 'td-overflow',
          colStyle: {
            width: '200px'
          }
        },
        {
          title: 'Embalaje',
          field: 'embalaje',
          sortable: true,
          filterable: true,
          thComp: 'FilterTh',
          tdClass: 'td-overflow',
          colStyle: {
            width: '200px'
          }
        },
        {
          title: 'Calidad',
          field: 'calidad',
          sortable: true,
          filterable: true,
          thComp: 'FilterTh',
          tdClass: 'text-center',
          colStyle: {
            width: '110px'
          }
        },
        {
          title: 'Cantidad<br>producida',
          field: 'cantidad',
          sortable: true,
          filterable: true,
          thComp: 'FilterTh',
          tdClass: 'text-center',
          colStyle: {
            width: '160px'
          }
        },
        {
          title: 'Error',
          field: 'error',
          sortable: true,
          filterable: true,
          thComp: 'FilterTh',
          colStyle: {
            width: '300px'
          },
          tdStyle: {
            'white-space': 'nowrap',
            'overflow': 'hidden',
            'text-overflow': 'ellipsis',
          }
        },
        {
          title: 'Actions',
          field: 'actions',
          fixed: 'right',
          thComp: 'EmptyTh',
          colStyle: {
            width: '65px'
          },
          tdStyle: {
            'height': '61px'
          }
        }
      ],
      keys: {
        embalaje: 0
      }
    }
  },
  methods: {
    onTreeSelect(slot,) {
      setTimeout(() => {
        this.updateHeightRows()
      }, 250);
      if (slot == 'cultivo') {
        this.keys.embalaje++
      }
    },
    updateAll() {
      this.selection = []
      this.keys.embalaje++
    },
    mapChunkData(item){
      return {
        dirty: false,
        errors: this.parseErrors(item.payload.encabezado),
        nanoid: item.payload.encabezado.nanoid,
        fechahora: item.payload.encabezado.fechahora,
        fechahora_amigable: this.dateFormat(item.payload.encabezado.fechahora),
        ubicaciones: item.payload.encabezado.ubicaciones,
        cultivo_id: item.payload.encabezado.cultivo_id,
        embalaje: item.payload.encabezado.embalaje,
        calidad: item.payload.encabezado.calidad,
        cantidad: item.payload.encabezado.cantidad,
        package: item.payload.encabezado.package || null,
        version: item.payload.encabezado.version || null,
        firma: item.payload.encabezado.firma || null,
        ubicacion_raiz_id: item.payload.encabezado.ubicacion_raiz_id,
        error: item.error,
        file: item.file
      }
    },
    consultarDocumentos() {
      return this.syncConsultar_().catch( error  => {
        console.log(error)
      })
    },
    parseErrors(item) {
      let errors = []

      item.ubicaciones = item.ubicaciones.map(ubicacion_id => {
        const ubicacion_correcta = this.ubicaciones.find(ubicacion => {
          return ubicacion_id == ubicacion.id && ubicacion.cultivo_id == item.cultivo_id
        })
        if (ubicacion_correcta) {
          return ubicacion_id
        }
        return  -1
      })

      let ubicacionesIds = this.ubicaciones.map(u => u.id)
      let ubicaciones = item.ubicaciones.filter(ubicacion => !ubicacionesIds.includes(ubicacion))
      let cultivo = this.cultivos.find(cultivo => cultivo.id == item.cultivo_id)
      let embalaje = this.embalajes(!cultivo ? -1 : cultivo.id).find(embalaje => embalaje.id == item.embalaje)

      if (!cultivo) {
        errors.push('cultivo_id')
      }
      if (!embalaje) {
        errors.push('embalaje')
      }
      if (ubicaciones.length || !item.ubicaciones.length) {
        errors.push('ubicaciones')
      }
      return errors
    }
  },
  computed: {
    dirtyDocuments() {
      return [...this.data]
        .filter(item => item.dirty == true)
        .map(item => {
          return {
            schema: "producciones",
            payload: {
              encabezado: {
                nanoid: item.nanoid,
                package: item.package,
                version: item.version,
                firma: item.firma,
                fechahora: item.fechahora,
                ubicaciones: item.ubicaciones ?? [],
                cultivo_id: item.cultivo_id ?? null,
                embalaje: item.embalaje,
                calidad: Number(item.calidad || 0),
                cantidad: Number(item.cantidad || 0),
                ubicacion_raiz_id: item.ubicacion_raiz_id
              }
            },
            file: item.file
          };
        });
    },
    unDirtyDocuments() {
      return this.selection.map((item) => {
          return {
            schema: "producciones",
            payload: {
              encabezado: {
                nanoid: item.nanoid,
                package: item.package,
                version: item.version,
                firma: item.firma,
                fechahora: item.fechahora,
                ubicaciones: item.ubicaciones ?? [],
                cultivo_id: item.cultivo_id ?? null,
                embalaje: item.embalaje,
                calidad: Number(item.calidad || 0),
                cantidad: Number(item.cantidad || 0),
                ubicacion_raiz_id: item.ubicacion_raiz_id
              }
            },
            file: item.file
          };
        });
    }
  }
};
</script>
<style src="spinkit/spinkit.min.css"></style>
<style scoped>
>>> .td-overflow {
  overflow: hidden;
}
>>> .ceil-error {
  box-shadow: 0px 0px 0px 1000px #f5b4b5
}
>>> .ubi-error {
  background: #ffe2e2;
  border: 1px solid #ff8181;
  color: #ff8181;
}
>>> [name="RightFixedTableHeader"] .table thead th {
    vertical-align: bottom;
    border-bottom: none;
}
>>> [name="TableBodyWrapper"] {
  margin-top: 0 !important;
}
</style>
